// Some MsTeams deeplinks where generated with BOM characters added from whatever the link was copied from before it was generated
// Normally we would get these links regenerated but they have been used in a large marketing campaign and it's too late to change them
// So we must strip them out where possible
export const stripBOM = (value: string) =>
    value ? value?.replace('\ufeff', '') : value
